module.exports = __webpack_public_path__ + "static/home1-top-banner-0bae0198a2dcc72821d6026b1ed65276.png";